export default __webpack_public_path__ + "static/media/interview.2f40244b.svg";